import { ColorTokens, FontFamilyTokens, FontSizeTokens, } from '@voltmoney/schema';
export const args = {
    title: {
        label: 'Selected MF portfolio',
        fontSize: FontSizeTokens.XS,
        fontFamily: FontFamilyTokens.Inter,
        fontWeight: '400',
        color: ColorTokens.Grey_Charcoal,
        lineHeight: 18,
    },
    subTitle: {
        label: '₹60,000',
        fontSize: FontSizeTokens.MD,
        fontFamily: FontFamilyTokens.Poppins,
        fontWeight: '700',
        color: ColorTokens.Grey_Night,
        lineHeight: 24,
    },
    actionText: 'Edit',
    ctaText: 'Get more MF porfolio',
    quotationText: {
        label: 'Want to increase limit by adding more MFs? ',
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
        fontWeight: '600',
        color: ColorTokens.Grey_Night,
        lineHeight: 24,
    },
    quotationSubText: {
        label: 'We’ll get your MF portfolio from other sources ',
        fontSize: FontSizeTokens.XS,
        fontFamily: FontFamilyTokens.Inter,
        fontWeight: '400',
        color: ColorTokens.Grey_Night,
        lineHeight: 18,
    },
    onPress: () => { },
};
export const argTypes = {};
